module.exports = __webpack_public_path__ + "img/status-2-glow.04895255.png";